import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { DesignElementController } from 'cd-eft/services/eftSetApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as SETAPI from 'cd-eft/services/eftSetApi';
import { removeOriginalDEMLayers } from 'cd-eft/components/common/DemIntegration/DemIntegrationVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';


const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;
const designController = SETAPI.DesignElementController;

export class DEMSurfaceSummaryTableVM {

  elementActions = {
    Edit: { action: this.openEditDEMHandler,disabled:setStore.isStatePlane },
    Delete: { action: this.deleteDEMHandler },
  };
  @observable props;
  constructor(props: any) {
    this.props = props; 
  }
  @observable savedDEM = false;
  @observable demToDelete = { demName: '', demType: '' };
  @observable demToEdit: any = {};
  @action.bound importDEMHandler() {
    setStore.currentDEM.demId = 'New DEM';
    setStore.currentTab = 'New DEM';
    setStore.currentDEM.demType = 10;
    setStore.isImportingNewDEM = true;
    setStore.importDEMWindowIsOpen = true;
    designStore.contourInterval=2;
  }

  @action.bound async updateDEM() {
    getDEMs();
  }

  @action.bound async openEditDEMHandler(e: any, item: any) {
    setStore.currentDEM = { ...item }
    setStore.currentDEM.demName = item.demSurfaceName;
    setStore.currentDEM.demId = 'New DEM';
    setStore.currentTab = 'New DEM';
    setStore.currentDEM.demType = 10;
    setStore.importDEMWindowIsOpen = true;
    setStore.isImportingNewDEM = false;
    setStore.isContourIntervalEdited = false;

    const res = await PRJAPI.SpatialRefControllerApi.getSpatialRefByProjectUuidUsingGET(designStore.projectsStore.currentProject.projectUuid);
    designStore.contourInterval=Number(res.data.contourInterval);
  }

  @action.bound async deleteDEMHandler(e: any, item: any) {
    this.setDEMToDelete(item);
    this.deleteDEMWindowIsOpen = true; // open popup window to let user confirm
  }
  @observable deleteDEMWindowIsOpen: boolean = false;

  @action.bound setDEMToDelete(item: any) {
    this.demToDelete.demName = item.demSurfaceName;
  }

  @action.bound toggleDeleteDEM() {
    this.deleteDEMWindowIsOpen = !this.deleteDEMWindowIsOpen;
  }

  @action.bound async deleteDEM() {
    setStore.isLoading = true;
    this.toggleDeleteDEM();
    try {
      if (designStore.projectsStore.currentProject.projectUuid === undefined) return;
      const response = await designController.deleteDemFileByProjectUuidUsingDELETE(
        designStore.projectsStore.currentProject.projectUuid,
      );
      if (response == undefined || response.data == undefined) {
        //delete service fails
        designStore.setLoader('');
      }
      else {
        setStore.savedDEM = false;
      }
      getDEMs();
      removeOriginalDEMLayers();

    this.props.designREF.in_dem_file = undefined;
    this.props.designREF.result_dem = undefined;
    this.props.designREF.result_dem_boundary = undefined;
    this.props.designREF.resultsGroupLayer.removeAll();
    }
    catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      setStore.isLoading = false;
    }
  }
  // <-- delete survey dialog

  @action.bound handleCheckboxChange = (e: any) => {
    //TODOs: handle checkbox onclick functionality 
  };
}

export const getDEMs = async () => {
  setStore.demSurfaceSummaryTable = [];
  if (!designStore?.projectsStore?.currentProject?.projectUuid) return;

  setStore.isLoading = true;
  try {
    const response: any = await DesignElementController.getDEMMetadataByProjectUuidUsingPOST(
      designStore.projectsStore.currentProject.projectUuid
    );
    if (response && response.data && response.data.projectUuid != null && response.data.demSurfaceName != "") {
      setStore.demSurfaceSummaryTable.push(response.data);
      setStore.savedDEM = true;
      setStore.in_designTypeSelection = 'demSurface';
    }

    MessageCenter.clearMessages();
  } catch (error) {
    //MessageCenter.addError((error as Error).message);
  }
  setStore.isLoading = false;
};



